import React, { Fragment } from 'react';
import './estilosComponente.css';
import './mediaqueriesComponente.css';

const MisLogros =()=>{

    let mostrarLaboral;
    let styleLaboral;
    let mostrarAcademico;
    let styleAcademico;

    /*Evento de botones*/

    window.addEventListener("resize", ()=>{
        if(window.screen.width < 550){
            mostrarLaboral.style.display="flex";
            mostrarAcademico.style.display="none";
            styleLaboral.style.border="2px solid #fff";
            styleAcademico.style.border="none";
        }else if (window.screen.width > 550){
            mostrarLaboral.style.display="flex";
            mostrarAcademico.style.display="flex";
        }
    });

    const handleCambiar =(event)=>{
        event.preventDefault();

            mostrarAcademico = document.getElementById("logro-academico");
            mostrarAcademico.style.display="none";
    
            mostrarLaboral = document.getElementById("logro-laboral");
            mostrarLaboral.style.display="flex";
    
            styleLaboral = document.getElementById("boton-laboral");
            styleLaboral.style.border="2px solid #fff";
    
            styleAcademico = document.getElementById("boton-academia");
            styleAcademico.style.border="none";

    };

    const handleCambiarDos =(event)=>{
        event.preventDefault();

            mostrarLaboral = document.getElementById("logro-laboral");
            mostrarLaboral.style.display="none";
    
            mostrarAcademico = document.getElementById("logro-academico");
            mostrarAcademico.style.display="flex";
    
            styleAcademico = document.getElementById("boton-academia");
            styleAcademico.style.border="2px solid #fff";
    
            styleLaboral = document.getElementById("boton-laboral");
            styleLaboral.style.border="none";

    };

    return(
        <Fragment>

            <div className='contenedor-logros'>

                <div 
                className='logro-academico' 
                id="logro-academico">
                    <div className='titulo-academico'>Academic</div>

                    <div className ='item-logro'>
                        <i className="fas fa-check-circle"></i> Mention "Cum Laude" for academic excellence
                    </div>
                    <div className='item-institucion'>Rafael Landívar University</div>

                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Merit honor for high academic performance
                    </div>
                    <div className='item-institucion'>Education supervision of Antigua Guatemala</div>

                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> De la Riva Award for Student Excellence
                    </div>
                    <div className='item-institucion last-line'>De la Riva Industries</div>

                </div>

                <div 
                className='logro-laboral' 
                id="logro-laboral">
                    <div className='titulo-laboral'>Work</div>

                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Improvement in customer service KPI, obtaining an average of 90% (2020)
                    </div>
                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Organization and holding of the first Regional Purchasing Workshop:
                        México, Central America and Colombia (2020)
                    </div>
                    <div className='item-institucion'>Onelink Solutions Guatemala, S.A.</div>

                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Participation in the design, development and execution of the purchasing department (2016)
                    </div>
                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Record in the reduction of costs and expenses in purchasing management (2017)
                    </div>
                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Participation in migration process to SAP system (2018)
                    </div>
                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Organization and holding of the first national purchasing workshop (2018)
                    </div>
                    <div className='item-logro'>
                        <i className="fas fa-check-circle"></i> Participation in certification process IFA (2018)
                    </div>
                    <div className='item-institucion'>Yara Guatemala, Sociedad Anónima</div>
                </div>

            </div>

            <div className='contenedor-boton-logro'>

                <button 
                className='boton-laboral' 
                id="boton-laboral" 
                onClick={handleCambiar}>
                    <i className="fas fa-caret-left"></i>
                </button>

                <button 
                className='boton-academia' 
                id="boton-academia" 
                onClick={handleCambiarDos}>
                    <i className="fas fa-caret-right"></i>
                </button>

            </div>
    
        </Fragment>
    );
};

export default MisLogros;